const rad1Router = [
  {
    path: '/first',
    name: 'first',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/first'),
    meta: {
      title: '房屋信息确认'
    }
  },
  {
    path: '/second',
    name: 'second',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/second'),
    meta: {
      title: '户型信息确认'
    }
  },
  {
    path: '/third',
    name: 'third',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/third'),
    meta: {
      title: '家庭成员情况'
    }
  },
  {
    path: '/fourth',
    name: 'fourth',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/fourth'),
    meta: {
      title: '职业与生活习惯'
    }
  },
  {
    path: '/fifth',
    name: 'fifth',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/fifth'),
    meta: {
      title: '装修关注点'
    }
  },
  {
    path: '/sixth',
    name: 'sixth',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/sixth'),
    meta: {
      title: '性格倾向'
    }
  },
  {
    path: '/seventh',
    name: 'seventh',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/seventh'),
    meta: {
      title: '空间状态偏好'
    }
  },
  {
    path: '/eighth',
    name: 'eighth',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/eighth'),
    meta: {
      title: '风格初体验'
    }
  },
  {
    path: '/ninth',
    name: 'ninth',
    component: () => import('@/views/wxapp/rad/rad1/filesInformation/ninth'),
    meta: {
      title: '上传户型图'
    }
  },
  {
    path: '/cover',
    name: 'cover',
    component: () => import('@/views/wxapp/rad/rad1/cover'),
    meta: {
      title: '初步需求评估邀请'
    }
  },
  {
    path: '/user-cover',
    name: 'user-cover',
    component: () => import('@/views/wxapp/rad/rad1/cover/userCover'),
    meta: {
      title: '初步需求评估'
    }
  },
  {
    path: '/resalt',
    name: 'resalt',
    component: () => import('@/views/wxapp/rad/rad1/assessmentResalt'),
    meta: {
      title: '查看结果'
    }
  }
]
export default rad1Router
